/**
 * Пропорция кадра против формата ролика (задача Оли №323). Отдельный модуль без импортов: его
 * грузит `node --test` (алиас `@/…` там не разрешается), а панель «Ракурсы» — как обычный модуль.
 */

/** Формат ролика: монтаж собирает 1080×1920. Кадр другой пропорции в клипе обрежется по центру. */
const VIDEO_RATIO = 9 / 16;
/** Допуск: 1088×1920 (наш формат генерации ракурсов) и подобные «почти 9:16» тревожить незачем. */
const RATIO_EPS = 0.02;

/**
 * Кадр заметно не 9:16: его обрежут при сборке ролика, и рамку лучше дать человеку, а не резать по
 * центру молча. Размеров стилла в таймлайне нет — панель берёт их из загруженного превью, поэтому
 * `undefined` значит «ещё не знаем», а не «всё хорошо».
 */
export const offRatio = (size: { w: number; h: number } | undefined): boolean =>
  !!size && size.w > 0 && size.h > 0 && Math.abs(size.w / size.h - VIDEO_RATIO) > RATIO_EPS;

/** Сервис не режет куски мельче этого по короткой стороне (`results.CROP_MIN_SIDE`). */
const MIN_SIDE = 320;

/**
 * Рамку 9:16 в окне нельзя растянуть — тянется только положение. Значит у маленькой картинки
 * «Обрезать» отказал бы всегда, и кнопку лучше не показывать вовсе (ревью 16.10): короткая сторона
 * будущего куска — ширина рамки 9:16, вписанной в картинку.
 */
export const cropTooSmall = (size: { w: number; h: number } | undefined): boolean => {
  if (!size || size.w <= 0 || size.h <= 0) return false;
  const width = size.w / size.h > VIDEO_RATIO ? size.h * VIDEO_RATIO : size.w;
  return width < MIN_SIDE;
};
